import React from 'react';
import MuiButton from '@mui/material/Button';
import Spinner from '../Spinner/Spinner';
import { useStyles } from './Button.styles';

export default function Button({ children, isLoading = false, ...rest }) {
    const classes = useStyles();

    return (
        <MuiButton {...rest}>
            {isLoading ? <Spinner size={20} className={classes.spinner} /> : children}
        </MuiButton>
    );
}
